/** Compara pathname com prefixo de rota (ignora barra final). */
export function matchesRoutePrefix(path: string, prefix: string): boolean {
  const base = prefix.replace(/\/$/, '');
  return path === base || path.startsWith(`${base}/`);
}

export function pathMatchesAnyPrefix(
  pathname: string | undefined,
  prefixes: readonly string[],
  fallbackPath = '/',
): boolean {
  const path = (pathname ?? fallbackPath).replace(/\/$/, '') || '/';
  return prefixes.some((prefix) => matchesRoutePrefix(path, prefix));
}
